import React from "react";
import subbanner from "../assets/images/sub-banner.jpg";

// Define prop types
interface SubbannerProps {
  height?: string;
  className?: string;
}

const Subbanner: React.FC<SubbannerProps> = ({
  height = "80vh",
  className = "",
}) => {
  return (
    <div
      className={`relative w-full ${className}`}
      style={{ height }}
    >
      <img src={subbanner} alt="Banner" className="w-full h-full object-cover" />
    </div>
  );
};

export default Subbanner;
